import Vue, { CreateElement, VNodeChildren } from 'vue';
import EButton from './Button.vue';
import AddIconPrimary from '../../Icons/AddIconPrimary.vue';
import VARIANT from './ButtonType/constant/variant';

export default EButton.extend({
  props: {
    leftIcon: {
      default: () => AddIconPrimary,
    },
  },
  computed: {
    hasIcon() {
      // @ts-ignore
      return !!this.leftIcon;
    },
  },
});
